import { render, staticRenderFns } from "./WorkingFile.vue?vue&type=template&id=678dc8d4&"
import script from "./WorkingFile.vue?vue&type=script&lang=js&"
export * from "./WorkingFile.vue?vue&type=script&lang=js&"
import style0 from "./WorkingFile.vue?vue&type=style&index=0&id=678dc8d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports